import { rightPad, zeroPad } from '../text/padding';
var LocalTime = /** @class */ (function () {
    function LocalTime(hour, minute, second, millisecond) {
        if (second === void 0) { second = 0; }
        if (millisecond === void 0) { millisecond = 0; }
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
    }
    LocalTime.parse = function (s) {
        var match = /^(\d{2}):(\d{2})(:(\d{2})(\.(\d{1,9}))?)?$/.exec(s);
        if (!match)
            throw new SyntaxError('Invalid LocalTime: ' + s);
        var second = match[4] || '0';
        var millisecond = rightPad((match[6] || '0').slice(0, 3), 3, '0');
        return new LocalTime(parseInt(match[1]), parseInt(match[2]), parseInt(second), parseInt(millisecond));
    };
    LocalTime.prototype.toJSON = function () {
        var millis = zeroPad(this.millisecond, 3);
        return "".concat(zeroPad(this.hour, 2), ":").concat(zeroPad(this.minute, 2), ":").concat(zeroPad(this.second, 2), ".").concat(millis);
    };
    LocalTime.prototype.toString = function () {
        return this.toJSON();
    };
    LocalTime.prototype.toHhmmssString = function () {
        return "".concat(zeroPad(this.hour, 2), ":").concat(zeroPad(this.minute, 2), ":").concat(zeroPad(this.second, 2));
    };
    return LocalTime;
}());
export { LocalTime };
